import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Stack, Typography } from '@mui/material';

import Iconify from 'src/components/iconify';

export default function NoSubmissions() {
  const { t } = useTranslation();
  return (
    <Card
      width="100%"
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: 3,
        justifyContent: 'center',
        minHeight: '100px',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Iconify icon="eva:alert-triangle-fill" width={40} height={40} color="orange" />
        <Typography variant="h6">{t('surveyDashboard.noSubmissions')}</Typography>
      </Stack>
    </Card>
  );
}
